import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Login.css";
import PhoneInput from "react-phone-input-2";
import { gettoastsuccess, gettoastwarning } from "../../Utils/Common";
import API from '../../Utils/Api';
import { validateForm } from "../../Utils/validate";
import { useAuth } from "../../hooks/useAuth";
import CustomLoader from "../../components/CustomLoader";
import { signInWithPopup } from "firebase/auth";
import { auth, googleProvider } from "../../Utils/firebase";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

const Login = () => {

  

  const { login } = useAuth();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [countryCode, setCountryCode] = useState('+353');
  const [inputs, setInputs] = useState({ mobile_number: '', mobile_number_only: '', password: '', push_token: '' });
  const handleInputChange = (event) => {
    setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));
  }
  const handleInputChangeCustom = (field, value) => {
    setInputs({ ...inputs, [field]: value })
  }
  const handleSubmit = async (event) => {
    event.preventDefault();
    const fields = [
      { field: 'mobile_number', label: 'Phone Number', rules: 'required|number', value: (inputs.mobile_number_only).trim() },
      { field: 'password', label: 'Password', rules: 'required', value: inputs.password },
    ];
    console.log('fields', fields);

    const errors = validateForm(fields);

    if (Object.keys(errors).length > 0) {
      setErrors(errors);
    } else {
      setErrors({});
      doLogin();
    }
  }
  const doLogin = async () => {
    setLoading(true);
    let error;
    try {
      const formInputs = { ...inputs, mobile_number: countryCode + inputs.mobile_number_only, push_token: '' }
      console.log('login inputs', formInputs);
      API.post('login', formInputs)
        .then(response => {
          setLoading(false);
          const apiResponse = response.data;
          console.log('login response', response.data);
          if (response.data.status === false) {
            gettoastwarning(response.data.message);
          } else {

            
            if(localStorage.getItem('prev_page'))
            {
              window.location.replace(localStorage.getItem('prev_page'));
              //gettoastsuccess(response.data.message, localStorage.getItem('prev_page'), 1000);
            }else{
              window.location.replace("/dating-masterclass");
              //gettoastsuccess(response.data.message, '/dating-masterclass', 1000);
            }
            login(apiResponse?.data?.token)
          }
        }).catch(e => {
          error = e.message;
          gettoastwarning(error);
        });
    } catch (e) {
      setLoading(false);
      error = e.message;
      gettoastwarning(error);
    }
  };
  /* Social Login */
  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const socialUserData = result.user;
      const socialUserTokenRes = result._tokenResponse;
      
      const email = socialUserData?.email;
      // const provider_id = socialUserData.uid; 
      
      // console.log('signed in user', result);
      const userData = { type: 'google', first_name: socialUserTokenRes?.firstName, last_name: socialUserTokenRes?.lastName, email, social_token: socialUserData?.providerData?.[0]?.uid }
      console.log('userData',userData);
      
      doSocialLogin(userData);

    } catch (error) {
      console.error("Google Sign-In Error:", error);
      gettoastwarning("Google login failed. Please try again later.");
    }
  };
  
  const doSocialLogin = async (user_data) => {
    setLoading(true);
    let error;
    try {
      const formInputs = { ...user_data }
      console.log('login_with_social inputs', formInputs);
      API.post('login_with_social', formInputs)
        .then(response => {
          setLoading(false);
          const apiResponse = response.data;
          console.log('login_with_social response', response.data);
          if (response.data.status === false) {
            gettoastwarning(response.data.message);
          } else {
            if(localStorage.getItem('prev_page'))
            {
              gettoastsuccess(response.data.message, localStorage.getItem('prev_page'), 1000);
            }else{
              gettoastsuccess(response.data.message, '/dating-masterclass', 1000);
            }
            login(apiResponse?.data?.token)
          }
        }).catch(e => {
          error = e.message;
          gettoastwarning(error);
        });
    } catch (e) {
      setLoading(false);
      error = e.message;
      gettoastwarning(error);
    }
  };
 const handleFacebookLogin = (res) => {
  //console.log(res);
    try {
      
      const userData = { type: 'facebook', first_name: res?.first_name, last_name: res?.last_name, email:res?.email, social_token: res?.id }
      console.log('userData',userData);
      
      doSocialLogin(userData);

    } catch (error) {
      console.error("Facebook Sign-In Error:", error);
      gettoastwarning("Facebook login failed. Please try again later.");
    }
  };

  useEffect(() => {
    document.title = `Login | Your Friend My Friend`;
    document.getElementById('bodywrap').className = 'brand';

    const authToken = localStorage.getItem("auth_token");
    if(authToken)
    {
      window.location.href = "/dating-masterclass";
    }
  }, []);
  return (
    <>
      <CustomLoader loading={loading} />
      <div className="container-fluid d-flex align-items-center justify-content-center min-vh-100 lo-oma">
        <div className="row w-100 my-5">
          <div className="col-md-6 col-lg-4 mx-auto">
            <div className="p-2">
              <h3 className="text-center mb-4">Log in</h3>
              <form method="post" onSubmit={handleSubmit} encType="multipart/form-data">
                {/* Email */}
                {/* <div className="mb-3">
                  <div className="input-group">
                    <span className="input-group-text">
                      <img
                        src={process.env.REACT_APP_BASE_URL + "assests/images/email-frame.png"}
                        alt="email"
                        className="img-fluid"
                      />
                    </span>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email address"
                    />
                  </div>
                </div> */}
                <div className="mb-3">
                  <PhoneInput
                    country={"ie"}
                    placeholder="Phone number"
                    inputProps={{
                      name: "mobile_number",
                      required: true,
                      autoFocus: true,
                    }}
                    inputStyle={{ width: "100%" }}
                    value={inputs.mobile_number}
                    containerClass={`${errors.mobile_number ? 'form-error' : ''}`}
                    onChange={(value, countryData = {}, event) => {
                      const dialCode = countryData.dialCode || '';
                      console.log('dialCode', dialCode);

                      // Remove dial code from the value (with '+' just to be safe)
                      let numberWithoutCode = value;


                      if (dialCode) {
                        const cleanDial = `+${dialCode}`;
                        if (value.startsWith(cleanDial)) {
                          numberWithoutCode = value.slice(cleanDial.length);
                        } else if (value.startsWith(dialCode)) {
                          numberWithoutCode = value.slice(dialCode.length);
                        }
                      }
                      console.log('numberWithoutCode', numberWithoutCode);
                      setCountryCode(`+${dialCode}`);
                      handleInputChange(event)
                      handleInputChangeCustom('mobile_number_only', numberWithoutCode)
                    }}
                  />
                  {errors.mobile_number && (
                    <p className="text-danger error-text">{errors.mobile_number}</p>
                  )}
                </div>
                {/* Password */}
                <div className="mb-2">
                  <div className={`input-group ${errors.password ? 'form-error' : ''}`}>
                    <span className="input-group-text">
                      <img
                        src={process.env.REACT_APP_BASE_URL + "assests/images/icon_password.png"}
                        alt="password"
                        className={`img-fluid input-icon`}
                      />
                    </span>
                    <input
                      type={showPassword ? "text" : "password"}
                      className={`form-control`}
                      placeholder="Password"
                      name="password"
                      onChange={handleInputChange}
                    />
                    <span className="input-group-text" style={{ cursor: "pointer" }} onClick={() => setShowPassword(!showPassword)}>
                      <img
                        src={
                          process.env.REACT_APP_BASE_URL +
                          (showPassword
                            ? "assests/images/icon_eye.png"
                            : "assests/images/icon_eye_slash.png")
                        }
                        alt="toggle-visibility"
                        className="img-fluid input-icon"
                      />
                    </span>
                  </div>
                  {errors.password && (
                    <p className="text-danger error-text">{errors.password}</p>
                  )}
                </div>
                <div className="text-end mb-3">
                  <Link to="/forgot-password" className="forgo">
                    Forgot Password?
                  </Link>
                </div>
                {/* Login button */}
                <div className="d-grid mb-3 text-center">
                  <button className="logus-in" type="submit">
                    LOGIN
                  </button>
                </div>
              </form>
              {/* OR divider */}
              <div className="text-center my-3 mt-5 divider">
                <span className="oru">Or</span>
                <hr />
              </div>
              {/* Social buttons */}
              <div className="d-grid gap-3 mb-4">
                {/*<Link to="" className="d-flex align-items-center justify-content-center face-bor" onClick={handleFacebookLogin}>
                  <img
                    src={process.env.REACT_APP_BASE_URL + "assests/images/icon_facebook.png"}
                    alt="facebook"
                    className="img-fluid input-icon"
                  /> Login with Facebook
                </Link>*/}
                <FacebookLogin
                appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                autoLoad={false}
                fields="id,name,email,first_name,last_name,picture"
                callback={handleFacebookLogin}
                render={(renderProps) => (
                  <Link to="" className="d-flex align-items-center justify-content-center face-bor" onClick={renderProps.onClick} >
                  <img
                    src={process.env.REACT_APP_BASE_URL + "assests/images/icon_facebook.png"}
                    alt="facebook"
                    className="img-fluid input-icon"
                  /> Login with Facebook
                </Link>
                )}
              />
                <Link to="" className="d-flex align-items-center justify-content-center face-bor" onClick={handleGoogleLogin}>
                  <img
                    src={process.env.REACT_APP_BASE_URL + "assests/images/icon_google.png"}
                    alt="google"
                    className="img-fluid input-icon"
                  /> Login with Google
                </Link>
              </div>
              {/* Register */}
              <p className="text-center register-ola mb-0">
                New to YFMF?{" "}
                <Link to="/signup">
                  Register Now
                </Link>
              </p>
            </div>
          </div>
        </div>

      </div>
    </>
  );
};
export default Login;
